import { isNil, get, partition, isArray } from "lodash"
import { ANALYZE_FACTORS_TAKE, COLORS } from "helpers/analyzeConstants"

/**
 * Filter items to only include those that have actual data points and assign colors
 * @param {Array} items - Array of item objects with id, label, etc.
 * @param {Array} data - Array of data objects containing the actual values
 * @returns {Array} Filtered items that have corresponding data with assigned colors
 */
export function filterItemsWithData(items, data) {
  if (!isArray(items) || !isArray(data) || data.length === 0) {
    return []
  }

  const filteredItems = items.filter(item => {
    return data.some(dataPoint => {
      return !isNil(get(dataPoint, item.id))
    })
  })

  const itemsWithMaxValues = appendMaxAbsValues(filteredItems, data)

  // Separate items that should keep original order (overall items and category totals) from other items (sort by max value)
  const [preserveOrderItems, sortableItems] = partition(
    itemsWithMaxValues,
    ({ item }) => item.type === "overall" || item.id.endsWith("_total"),
  )

  sortableItems.sort((a, b) => b.maxAbsValue - a.maxAbsValue)

  const sortedItems = [...preserveOrderItems.map(({ item }) => item), ...sortableItems.map(({ item }) => item)]

  const limitedItems = sortedItems.slice(0, ANALYZE_FACTORS_TAKE)

  return limitedItems.map((item, index) => ({
    ...item,
    color: item.color || COLORS[index % COLORS.length],
  }))
}

export function appendMaxAbsValues(items, data) {
  if (!isArray(items) || !isArray(data) || data.length === 0) {
    return []
  }

  return items.map(item => {
    const maxAbsValue = data.reduce((max, dataPoint) => {
      const value = get(dataPoint, item.id)
      const absValue = isNil(value) ? 0 : Math.abs(value)
      return Math.max(max, absValue)
    }, 0)
    return { item, maxAbsValue }
  })
}
